import React from "react";

interface Props {
  pageHeader: string;
  subHeadings: string[];
}

const MixAndMatchAboveContainerView = ({ pageHeader, subHeadings }: Props) => {
  const [firstSubHeading, ...additionalSubHeadings] = subHeadings || [];
  return (
    <div className="page-header-container">
      <h1 className="page-header">{pageHeader}</h1>
      {firstSubHeading && (
        <h2 className="page-header-2">
          {firstSubHeading}
          {!!additionalSubHeadings?.length &&
            additionalSubHeadings.map((subHeadingLine) => (
              <>
                <br />
                {subHeadingLine}
              </>
            ))}
        </h2>
      )}
    </div>
  );
};

export default MixAndMatchAboveContainerView;
